import { Link } from 'react-router-dom';

import { DownOutlined } from '@ant-design/icons';
import { Button, Col, Row, Spin, Typography } from 'antd';

import { formatDate } from 'helpers/date';
import TopPage from 'v2/components/Shared/TopPage';
import { useNewzzList } from 'v2/hooks/useNewzz';
import type { Newzz } from 'v2/services/newzz';

const NewzzList = () => {
  const { canLoadMore, newzz, clickNewzz, isLoading, loadMore, isFetching } = useNewzzList();

  return (
    <div className='w-full'>
      <TopPage title='Newzz' extra='Fique por dentro de todas as novidades da Eduzz' />

      <div>
        <Row justify='center' align='middle'>
          <Col xs={24} md={16} lg={16}>
            {newzz.map((item, index) => (
              <div key={`panel-${index}`} className='animate-slideUp'>
                {item.has_content ? (
                  <Link onClick={() => clickNewzz(item.id)} to={`/producer/news/info/${item.id}`}>
                    <NewzzItem item={item} />
                  </Link>
                ) : (
                  <a
                    onClick={() => clickNewzz(item.id)}
                    href={item.external_url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <NewzzItem item={item} />
                  </a>
                )}
              </div>
            ))}
          </Col>
          {canLoadMore && (
            <Col xs={24} md={16} lg={16} className='text-center'>
              <Button
                disabled={isLoading}
                onClick={() => loadMore()}
                className='rounded-sm border border-[#ddd] bg-white text-xs font-medium text-[#192542]'
                loading={isFetching}
                icon={<DownOutlined />}
              >
                Carregar mais
              </Button>
            </Col>
          )}
          {isLoading && <Spin />}
        </Row>
      </div>
    </div>
  );
};

const NewzzItem = ({ item }: { item: Newzz }) => (
  <div className='mb-[10px] flex flex-row items-center gap-2 rounded-sm border border-gray-200 bg-white p-[0.8rem] hover:opacity-50'>
    <Typography.Text className='block flex-1 p-[2px] text-left text-base font-semibold'>{item.title}</Typography.Text>
    <div className='flex-end flex flex-row items-center gap-2'>
      <Typography.Text className='block p-[2px] text-left text-base font-semibold text-[#009358]!'>
        {item.show_tag_new ? 'NOVO' : ''}
      </Typography.Text>
      <Typography.Text className='block text-right text-sm opacity-50'>
        {formatDate(item.created_at, 'dd/MM/yyyy')}
      </Typography.Text>
    </div>
  </div>
);

export default NewzzList;
